// Single chevron that toggles whether the left pages sidebar is visible.
// Two render modes, identical action:
//
//   - "edge": tucked into the top-right corner of the sidebar itself. Used
//     while the sidebar is expanded.
//   - "floating": absolutely positioned at the top-left of the iframe area
//     so the user has a way back when the sidebar is hidden.

type Props = {
  hidden: boolean;
  onToggle: () => void;
  variant: "edge" | "floating";
};

export function SidebarToggle({ hidden, onToggle, variant }: Props) {
  const label = hidden ? "Show pages list" : "Hide pages list";
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={label}
      title={label}
      className={
        variant === "floating"
          ? "absolute left-2 top-2 z-20 inline-flex h-7 w-7 items-center justify-center rounded-full border border-neutral-200 bg-white text-neutral-500 shadow-sm hover:text-neutral-900"
          : "inline-flex h-6 w-6 items-center justify-center rounded-md text-neutral-400 hover:bg-neutral-200 hover:text-neutral-700"
      }
    >
      {hidden ? <ChevronRight /> : <ChevronLeft />}
    </button>
  );
}

function ChevronLeft() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className="h-4 w-4"
    >
      <path
        d="M15 6l-6 6 6 6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ChevronRight() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className="h-4 w-4"
    >
      <path
        d="M9 6l6 6-6 6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
